import axios from 'axios';
import {getUrl} from '@/config/api.routes';


export default {
  namespaced: true,
  actions: {
    async getAll({ _ }, params = null) {
      const response = await axios.get(getUrl('aimanager.intent_suggestions'), {params});
      return response.data;
    },
    async selectRecommendation({ _ }, id) {
      const response = await axios.get(getUrl('aimanager.intent_suggestions', id));
      return response.data;
    },
    async loadSimilarIntents({ _ }, id) {
      const response = await axios.post(getUrl('aimanager.intent_suggestions', `${id}/similarity`));
      return response.data.data;
    },
    async feedbackSuggestion({ _ }, {id, payload}) {
      const response = await axios.put(getUrl('aimanager.intent_suggestions', `${id}/feedback`), payload);
      return response.data;
    },
    async mergeSuggestionToIntent({ _ }, {id, intent_obj}) {
      const response = await axios.put(getUrl('aimanager.intents', `${id}`), intent_obj);
      return response.data;
    },
  },
};